/**
 * @generated SignedSource<<23711dc6752a7094995d8efb756e1c1a>>
 * @relayHash 1dbbd240576b496aabf7631bbe5e8317
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ad6fa59108f9429438bd30d3273091c7c3dbac7714e0489bd218aecdc02623cc

import type { ConcreteRequest } from 'relay-runtime';
export type useGetTeamAndSubanchorGetSubanchorsAGGQuery$variables = {
  accountId: string;
};
export type useGetTeamAndSubanchorGetSubanchorsAGGQuery$data = {
  readonly growthUnifiedProfile_getUnifiedProfile: {
    readonly paidChannelContext: {
      readonly confluence: {
        readonly subAnchor: string | null;
      } | null;
    } | null;
  } | null;
};
export type useGetTeamAndSubanchorGetSubanchorsAGGQuery = {
  response: useGetTeamAndSubanchorGetSubanchorsAGGQuery$data;
  variables: useGetTeamAndSubanchorGetSubanchorsAGGQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "accountId"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "accountId",
        "variableName": "accountId"
      }
    ],
    "concreteType": "GrowthUnifiedProfileResult",
    "kind": "LinkedField",
    "name": "growthUnifiedProfile_getUnifiedProfile",
    "plural": false,
    "selections": [
      {
        "concreteType": "GrowthUnifiedProfilePaidChannelContextByProduct",
        "kind": "LinkedField",
        "name": "paidChannelContext",
        "plural": false,
        "selections": [
          {
            "concreteType": "GrowthUnifiedProfilePaidChannelContext",
            "kind": "LinkedField",
            "name": "confluence",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "subAnchor"
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useGetTeamAndSubanchorGetSubanchorsAGGQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useGetTeamAndSubanchorGetSubanchorsAGGQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "1dbbd240576b496aabf7631bbe5e8317",
    "id": "ad6fa59108f9429438bd30d3273091c7c3dbac7714e0489bd218aecdc02623cc",
    "metadata": {},
    "name": "useGetTeamAndSubanchorGetSubanchorsAGGQuery",
    "operationKind": "query",
    "text": "query useGetTeamAndSubanchorGetSubanchorsAGGQuery($accountId:ID!){growthUnifiedProfile_getUnifiedProfile(accountId:$accountId){paidChannelContext{confluence{subAnchor}}}}"
  }
};
})();

(node as any).hash = "41238e70a66e2ffbcfc5e10ca0de9d20";

export default node;
